import { Attr, BelongsTo, HasMany, Model } from "spraypaint";

import { ApplicationRecord } from "shared/services/spraypaint";
import type { Nullable } from "shared/types";

import type ContactList from "./ContactList";
import type ContactListsContact from "./ContactListsContact";
import type Organisation from "./Organisation";
import type { Email, Homepage, Phone, Social } from "./types";

@Model()
class PrivateOutlet extends ApplicationRecord {
  static jsonapiType = "private_outlets";

  @Attr({ persist: false }) archivedAt: string;

  @HasMany() contactLists: ContactList[];

  @HasMany() contactListsContacts: ContactListsContact[];

  @Attr({ persist: false }) createdAt: string;

  @Attr({ persist: false }) documentId: string;

  @Attr() email: string;

  @Attr({ persist: false }) emails: Email[];

  @Attr({ persist: false }) faxes: Phone[];

  @Attr({ persist: false }) homepages: Homepage[];

  @Attr() invalidEmail: boolean;

  @Attr() name: string;

  @Attr() note: string;

  @BelongsTo() organisation: Organisation;

  @Attr() organisationId: number;

  @Attr() outletId: Nullable<number>;

  @Attr() phone: string;

  @Attr({ persist: false }) phones: Phone[];

  @Attr({ persist: false }) socials: Social[];

  @Attr({ persist: false }) updatedAt: string;
}

export default PrivateOutlet;
